import { render, staticRenderFns } from "./SessionAccess.vue?vue&type=template&id=e70f2d24&scoped=true"
import script from "./SessionAccess.vue?vue&type=script&lang=js"
export * from "./SessionAccess.vue?vue&type=script&lang=js"
import style0 from "./SessionAccess.vue?vue&type=style&index=0&id=e70f2d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70f2d24",
  null
  
)

export default component.exports